// import { Grid } from "@mui/material";
// import React, { useEffect, useState, useCallback } from "react";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
// import WSButton from "../../../Components/Button/WSButton";
// import WSDataGridNew, {
//   IColumns,
// } from "../../../Components/DataGrid/WSDataGridNew";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import AddIcon from "@mui/icons-material/Add";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import { useNavigate } from "react-router-dom";
// import { getLocalValue, LoacalVariables, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import http from "../../../commonFunctions/httpClient";

// interface ScanBooking {
//   bookingId: string;
//   bookedOn: string;
//   labName: string;
//   labId: string;
//   customerName: string;
//   customerId: string;
//   testName: string;
//   slotDate: string;
//   slotTime: string;
//   paymentMethod: string;
//   amount: number;
//   resultAvailable: boolean;
//   reportUrl: string | null;
//   trackingId: string;
//   status: string;
//   itemTotal: number;
//   discount: number;
//   totalPayable: number;
//   savings: number;
//   formattedAmount: string;  // ✅ For currency display
// }

// interface SummaryCounts {
//   totalScans: number;
//   completedScans: number;
//   pendingScans: number;
//   todayScans: number;
//   revenueToday: number;
//   resultReady: number;
// }

// export const LabScanList: React.FC<any> = React.memo((props) => {
//   const navigate = useNavigate();

//   const filters = ["All", "Pending", "Completed", "Today"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);
//   const [data, setData] = useState<ScanBooking[]>([]);
//   const [filteredData, setFilteredData] = useState<ScanBooking[]>([]);
//   const [labId, setLabId] = useState<string>("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const [filterCounts, setFilterCounts] = useState<Record<string, number>>({
//     All: 0,
//     Pending: 0,
//     Completed: 0,
//     Today: 0,
//   });

//   const [summaryCounts, setSummaryCounts] = useState<SummaryCounts>({
//     totalScans: 0,
//     completedScans: 0,
//     pendingScans: 0,
//     todayScans: 0,
//     revenueToday: 0,
//     resultReady: 0,
//   });

//   useEffect(() => {
//     updateMainHeader("Scan Bookings");
//     breadCrumbsStore.updateBreadCrumbs([
//       { "Scan Bookings": "labscan/list" },
//     ]);
//   }, []);

//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setLabId(userId || "");
//   }, []);

//   const calculateFilterCounts = useCallback((scans: ScanBooking[]) => {
//     const today = new Date().toISOString().split('T')[0];

//     const pendingCount = scans.filter(scan => !scan.resultAvailable).length;
//     const completedCount = scans.filter(scan => scan.resultAvailable).length;
//     const todayCount = scans.filter(scan => scan.slotDate === today).length;

//     const counts: Record<string, number> = {
//       All: scans.length,
//       Pending: pendingCount,
//       Completed: completedCount,
//       Today: todayCount,
//     };

//     return counts;
//   }, []);

//   const fetchScanBookings = useCallback(async (): Promise<void> => {
//     if (!labId) {
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");

//       const response: any = await http.get(`lab/LabScanBooking/lab/${labId}`);
//       const apiData = response.data || response || [];

//       const scanBookings: ScanBooking[] = [];

//       if (Array.isArray(apiData)) {
//         apiData.forEach((bookingGroup: any) => {
//           const users = bookingGroup.users || [];
//           const scanInfos = bookingGroup.scanBookingInfo || [];
//           const results = bookingGroup.results || [];
//           const tracking = bookingGroup.orderTracking || [{}];
//           const orderSummary = bookingGroup.orderSummary?.[0] || {};

//           scanInfos.forEach((info: any, index: number) => {
//             const user = users[0] || { name: "Unknown", customerProfileId: "" };
//             const result = results[index] || { resultAvailable: false, reportPdfUrl: null };
//             const track = tracking[0] || { trackingId: "", steps: [] };

//             const status = result.resultAvailable ? "Completed" : "Pending";

//             scanBookings.push({
//               bookingId: info.bookingId,
//               bookedOn: info.bookedOn,
//               labName: info.lab?.labName || "Unknown Lab",
//               labId: info.lab?.labId || labId,
//               customerName: user.name,
//               customerId: user.customerProfileId,
//               testName: info.tests?.testName || "Unknown Scan",
//               slotDate: info.slot?.date?.split('T')[0] || "",
//               slotTime: info.slot?.time || "",
//               paymentMethod: info.payment?.method || "",
//               amount: info.payment?.amount || 0,
//               resultAvailable: result.resultAvailable || false,
//               reportUrl: result.reportPdfUrl || null,
//               trackingId: track.trackingId || "",
//               status,
//               itemTotal: orderSummary.itemTotal || 0,
//               discount: orderSummary.discount || 0,
//               totalPayable: orderSummary.totalPayable || 0,
//               savings: orderSummary.savings || 0,
//               formattedAmount: `₹${(orderSummary.totalPayable || 0).toFixed(2)}`,
//             });
//           });
//         });
//       }

//       setData(scanBookings);

//       const counts = calculateFilterCounts(scanBookings);
//       setFilterCounts(counts);
//       setFilteredData(scanBookings);

//     } catch (err: any) {
//       console.error("❌ fetchScanBookings error:", err);
//       setError(err.message || "Failed to fetch scan bookings");
//       setData([]);
//       setFilteredData([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [labId, calculateFilterCounts]);

//   const fetchSummaryCounts = useCallback(async (): Promise<void> => {
//     if (!labId || data.length === 0) return;

//     const today = new Date().toISOString().split('T')[0];
//     const todayRevenue = data
//       .filter(scan => scan.slotDate === today)
//       .reduce((sum, scan) => sum + scan.totalPayable, 0);

//     setSummaryCounts({
//       totalScans: data.length,
//       completedScans: data.filter(scan => scan.resultAvailable).length,
//       pendingScans: data.filter(scan => !scan.resultAvailable).length,
//       todayScans: data.filter(scan => scan.slotDate === today).length,
//       revenueToday: Math.round(todayRevenue),
//       resultReady: data.filter(scan => scan.resultAvailable).length,
//     });
//   }, [labId, data]);

//   useEffect(() => {
//     if (labId) {
//       fetchScanBookings();
//     }
//   }, [labId, fetchScanBookings]);

//   useEffect(() => {
//     fetchSummaryCounts();
//   }, [data, fetchSummaryCounts]);

//   const handleFilterChange = useCallback((value: string) => {
//     const originalFilter = value.replace(/\(\d+\)$/, "").trim();
//     setSelectedFilter(originalFilter);

//     const today = new Date().toISOString().split('T')[0];

//     if (originalFilter === "All") {
//       setFilteredData(data);
//     } else if (originalFilter === "Today") {
//       setFilteredData(data.filter(scan => scan.slotDate === today));
//     } else if (originalFilter === "Pending") {
//       setFilteredData(data.filter(scan => !scan.resultAvailable));
//     } else if (originalFilter === "Completed") {
//       setFilteredData(data.filter(scan => scan.resultAvailable));
//     }
//   }, [data]);

//   const getFilterLabel = useCallback((filter: string) => {
//     const count = filterCounts[filter] || 0;
//     return `${filter}(${count})`;
//   }, [filterCounts]);

//   useEffect(() => {
//     if (data.length > 0) {
//       const counts = calculateFilterCounts(data);
//       setFilterCounts(counts);
//     }
//   }, [data, calculateFilterCounts]);

//   const handleAction = async (action: string, row: ScanBooking) => {
//     if (action === "View") {
//       navigate(`/lab-scanning/view/${row.bookingId}`);
//     }
//   };

//   const handleAddNew = () => {
//     navigate("/lab-scan/add");
//   };

//   const columns: IColumns[] = [
//     { header: "Tracking ID", fieldName: "trackingId", type: "default" },
//     { header: "Customer", fieldName: "customerName", type: "default" },
//     { header: "Scan Name", fieldName: "testName", type: "default" },
//     { header: "Slot Date", fieldName: "slotDate", type: "date" },
//     { header: "Slot Time", fieldName: "slotTime", type: "default" },
//     { header: "Amount", fieldName: "formattedAmount", type: "default" },
//     { header: "Payment", fieldName: "paymentMethod", type: "default" },
//     { header: "Status", fieldName: "status", type: "status" },
//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["View"],
//       actionCallback: (action, row) => handleAction(action, row as ScanBooking),
//     },
//   ];

//   if (loading) {
//     return (
//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
//           <div>Loading scan bookings...</div>
//         </Grid>
//       </Grid>
//     );
//   }

//   return (
//     <>
//       <Grid container spacing={2}>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Total Scans"
//             value={summaryCounts.totalScans.toString()}
//             percentage="+5%"
//             bottomIcon={<TrendingUpIcon />}
//             icon={<ShoppingCartIcon sx={{ color: "#098963" }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Completed"
//             value={summaryCounts.completedScans.toString()}
//             percentage="+15%"
//             bottomIcon={<TrendingUpIcon />}
//             icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Pending"
//             value={summaryCounts.pendingScans.toString()}
//             percentage="-3%"
//             bottomIcon={<TrendingUpIcon />}
//             icon={<WSIcons.OutOfStockIcon sx={{ color: "#ff9800" }} />}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Today's Revenue"
//             value={`₹${summaryCounts.revenueToday}`}
//             percentage="+12%"
//             bottomIcon={<TrendingUpIcon />}
//             icon={<ShoppingCartIcon sx={{ color: "#098963" }} />}
//           />
//         </Grid>

//         <Grid item sm={9}>
//           <WSFilterButtonGroup
//             options={filters.map(filter => getFilterLabel(filter))}
//             selected={getFilterLabel(selectedFilter)}
//             onChange={handleFilterChange}
//           />
//         </Grid>
//         {/* <Grid item sm={3} display="flex" justifyContent="flex-end">
//           <WSButton
//             id="btnAddNewScan"
//             label="Add New Scan Booking"
//             startIcon={<AddIcon />}
//             onClick={handleAddNew}
//             sx={{
//               borderRadius: "999px",
//               backgroundColor: "#098963!important",
//               textTransform: "none",
//               fontWeight: 500,
//               height: "35px!important",
//               fontSize: "0.875rem!important",
//               paddingX: 3,
//               paddingY: 1,
//               "&:hover": { backgroundColor: "#087654!important" },
//             }}
//           />
//         </Grid> */}
//       </Grid>

//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid item sm={12}>
//           {error ? (
//             <div style={{ padding: 20, color: 'red' }}>
//               {error}. <button onClick={fetchScanBookings}>Retry</button>
//             </div>
//           ) : (
//             <WSDataGridNew
//               columns={columns}
//               data={filteredData}
//               id="labScanListGrid"
//               title={`Scan Bookings (${filteredData.length})`}
//               exportCsv={true}
//               searchBox={{ fieldName: "customerName" }}
//               gridHeaderSx={{
//                 backgroundColor: "whitesmoke",
//                 border: "1px solid whitesmoke",
//               }}
//             />
//           )}
//         </Grid>
//       </Grid>
//     </>
//   );
// });

// export default LabScanList;




// import { Grid, CircularProgress, Snackbar, Alert, Paper } from "@mui/material";
// import React, { useEffect, useState, useCallback } from "react";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
// import WSButton from "../../../Components/Button/WSButton";
// import WSDataGridNew, {
//     IColumns,
// } from "../../../Components/DataGrid/WSDataGridNew";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import AddIcon from "@mui/icons-material/Add";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import { useNavigate } from "react-router-dom";
// import { getLocalValue, LoacalVariables, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import http from "../../../commonFunctions/httpClient";

// interface ScanBooking {
//     bookingId: string;
//     bookedOn: string;
//     labName: string;
//     labId: string;
//     customerName: string;
//     customerId: string;
//     testName: string;
//     slotDate: string;
//     slotTime: string;
//     paymentMethod: string;
//     amount: number;
//     resultAvailable: boolean;
//     reportUrl: string | null;
//     trackingId: string;
//     status: string;
//     itemTotal: number;
//     discount: number;
//     totalPayable: number;
//     savings: number;
//     formattedAmount: string;
// }

// interface SummaryCounts {
//     totalScans: number;
//     completedScans: number;
//     pendingScans: number;
//     todayScans: number;
//     revenueToday: number;
//     resultReady: number;
// }

// export const LabScanList: React.FC<any> = React.memo((props) => {
//     const navigate = useNavigate();

//     const filters = ["All", "Pending", "Completed", "Today"];
//     const [selectedFilter, setSelectedFilter] = useState(filters[0]);
//     const [data, setData] = useState<ScanBooking[]>([]);
//     const [filteredData, setFilteredData] = useState<ScanBooking[]>([]);
//     const [labId, setLabId] = useState<string>("");
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState("");

//     // ✅ NEW STATES for status update
//     const [apiLoading, setApiLoading] = useState<Set<string>>(new Set());
//     const [snackbar, setSnackbar] = useState<{
//         open: boolean;
//         message: string;
//         severity: "success" | "error" | "info";
//     }>({
//         open: false,
//         message: "",
//         severity: "success",
//     });

//     const [filterCounts, setFilterCounts] = useState<Record<string, number>>({
//         All: 0,
//         Pending: 0,
//         Completed: 0,
//         Today: 0,
//     });

//     const [summaryCounts, setSummaryCounts] = useState<SummaryCounts>({
//         totalScans: 0,
//         completedScans: 0,
//         pendingScans: 0,
//         todayScans: 0,
//         revenueToday: 0,
//         resultReady: 0,
//     });

//     useEffect(() => {
//         updateMainHeader("Scan Bookings");
//         breadCrumbsStore.updateBreadCrumbs([
//             { "Scan Bookings": "labscan/list" },
//         ]);
//     }, []);

//     useEffect(() => {
//         const userId = getLocalValue(LoacalVariables.UserId);
//         setLabId(userId || "");
//     }, []);

//     const calculateFilterCounts = useCallback((scans: ScanBooking[]) => {
//         const today = new Date().toISOString().split('T')[0];

//         const pendingCount = scans.filter(scan => !scan.resultAvailable).length;
//         const completedCount = scans.filter(scan => scan.resultAvailable).length;
//         const todayCount = scans.filter(scan => scan.slotDate === today).length;

//         const counts: Record<string, number> = {
//             All: scans.length,
//             Pending: pendingCount,
//             Completed: completedCount,
//             Today: todayCount,
//         };

//         return counts;
//     }, []);

//     const fetchScanBookings = useCallback(async (): Promise<void> => {
//         if (!labId) {
//             setLoading(false);
//             return;
//         }

//         try {
//             setLoading(true);
//             setError("");

//             const response: any = await http.get(`lab/LabScanBooking/lab/${labId}`);
//             const apiData = response.data || response || [];
//             console.log("the reponse is ", response);

//             const scanBookings: ScanBooking[] = [];

//             if (Array.isArray(apiData)) {
//                 apiData.forEach((bookingGroup: any) => {
//                     const users = bookingGroup.users || [];
//                     const scanInfos = bookingGroup.scanBookingInfo || [];
//                     const results = bookingGroup.results || [];
//                     const tracking = bookingGroup.orderTracking || [{}];
//                     const orderSummary = bookingGroup.orderSummary?.[0] || {};

//                     scanInfos.forEach((info: any, index: number) => {
//                         const user = users[0] || { name: "Unknown", customerProfileId: "" };
//                         const result = results[index] || { resultAvailable: false, reportPdfUrl: null };
//                         const track = tracking[0] || { trackingId: "", steps: [] };

//                         const status = result.resultAvailable ? "Completed" : "Pending";

//                         scanBookings.push({
//                             bookingId: info.bookingId,
//                             bookedOn: info.bookedOn,
//                             labName: info.lab?.labName || "Unknown Lab",
//                             labId: info.lab?.labId || labId,
//                             customerName: user.name,
//                             customerId: user.customerProfileId,
//                             testName: info.tests?.testName || "Unknown Scan",
//                             slotDate: info.slot?.date?.split('T')[0] || "",
//                             slotTime: info.slot?.time || "",
//                             paymentMethod: info.payment?.method || "",
//                             amount: info.payment?.amount || 0,
//                             resultAvailable: result.resultAvailable || false,
//                             reportUrl: result.reportPdfUrl || null,
//                             trackingId: track.trackingId || "",
//                             status,
//                             itemTotal: orderSummary.itemTotal || 0,
//                             discount: orderSummary.discount || 0,
//                             totalPayable: orderSummary.totalPayable || 0,
//                             savings: orderSummary.savings || 0,
//                             formattedAmount: `₹${(orderSummary.totalPayable || 0).toFixed(2)}`,
//                         });
//                     });
//                 });
//             }

//             setData(scanBookings);

//             const counts = calculateFilterCounts(scanBookings);
//             setFilterCounts(counts);
//             setFilteredData(scanBookings);

//         } catch (err: any) {
//             console.error("❌ fetchScanBookings error:", err);
//             setError(err.message || "Failed to fetch scan bookings");
//             setData([]);
//             setFilteredData([]);
//         } finally {
//             setLoading(false);
//         }
//     }, [labId, calculateFilterCounts]);

//     const fetchSummaryCounts = useCallback(async (): Promise<void> => {
//         if (!labId || data.length === 0) return;

//         const today = new Date().toISOString().split('T')[0];
//         const todayRevenue = data
//             .filter(scan => scan.slotDate === today)
//             .reduce((sum, scan) => sum + scan.totalPayable, 0);

//         setSummaryCounts({
//             totalScans: data.length,
//             completedScans: data.filter(scan => scan.resultAvailable).length,
//             pendingScans: data.filter(scan => !scan.resultAvailable).length,
//             todayScans: data.filter(scan => scan.slotDate === today).length,
//             revenueToday: Math.round(todayRevenue),
//             resultReady: data.filter(scan => scan.resultAvailable).length,
//         });
//     }, [labId, data]);

//     // ✅ YOUR EXACT API: PUT /lab/LabScanBooking/start-processing/{bookingId}
//     // ✅ FIXED: http.put needs 2 arguments - URL + config object

//     const handleStatusUpdate = useCallback(async (bookingId: string) => {
//   console.log("🔄 handleStatusUpdate called with:", bookingId);

//   // ✅ PERSISTENT STORAGE for InProcess status
//   const inProcessKey = `scan-inprocess-${bookingId}`;
  
//   const currentScan = data.find(r => r.bookingId === bookingId);
//   if (!currentScan) {
//     setSnackbar({ open: true, message: "Scan booking not found", severity: "error" });
//     return;
//   }

//   if (currentScan.status === "InProcess") {
//     setSnackbar({ open: true, message: `Scan already in process`, severity: "info" });
//     return;
//   }

//   setApiLoading((prev) => {
//     const s = new Set(prev);
//     s.add(bookingId);
//     return s;
//   });

//   try {
//     const response: any = await http.put(`lab/LabScanBooking/start-processing/${bookingId}`, {});
//     console.log("📥 API RESPONSE:", response);

//     // ✅ IMMEDIATELY persist to localStorage
//     localStorage.setItem(inProcessKey, "true");

//     // ✅ Update local state
//     const updatedData = data.map(scan => 
//       scan.bookingId === bookingId
//         ? { ...scan, status: "InProcess" }
//         : scan
//     );
//     setData(updatedData);
//     setFilteredData(updatedData);

//     setSnackbar({
//       open: true,
//       message: `Scan processing started ✅`,
//       severity: "success",
//     });

//   } catch (error: any) {
//     console.error("❌ Error:", error);
//     localStorage.removeItem(inProcessKey); // Cleanup on error
//     setSnackbar({ 
//       open: true, 
//       message: error?.response?.data?.message || "Failed to start processing", 
//       severity: "error" 
//     });
//   } finally {
//     setApiLoading((prev) => {
//       const s = new Set(prev);
//       s.delete(bookingId);
//       return s;
//     });
//   }
// }, [data]);



//     useEffect(() => {
//         if (labId) {
//             fetchScanBookings();
//         }
//     }, [labId, fetchScanBookings]);

//     useEffect(() => {
//         fetchSummaryCounts();
//     }, [data, fetchSummaryCounts]);

//     const handleFilterChange = useCallback((value: string) => {
//         const originalFilter = value.replace(/\(\d+\)$/, "").trim();
//         setSelectedFilter(originalFilter);

//         const today = new Date().toISOString().split('T')[0];

//         if (originalFilter === "All") {
//             setFilteredData(data);
//         } else if (originalFilter === "Today") {
//             setFilteredData(data.filter(scan => scan.slotDate === today));
//         } else if (originalFilter === "Pending") {
//             setFilteredData(data.filter(scan => !scan.resultAvailable));
//         } else if (originalFilter === "Completed") {
//             setFilteredData(data.filter(scan => scan.resultAvailable));
//         }
//     }, [data]);

//     const getFilterLabel = useCallback((filter: string) => {
//         const count = filterCounts[filter] || 0;
//         return `${filter}(${count})`;
//     }, [filterCounts]);

//     useEffect(() => {
//         if (data.length > 0) {
//             const counts = calculateFilterCounts(data);
//             setFilterCounts(counts);
//         }
//     }, [data, calculateFilterCounts]);

//     // ✅ UPDATED handleAction - "In Process" calls YOUR API
//     const handleAction = async (action: string, row: ScanBooking) => {
//         console.log("Action:", action, "Row ID:", row.bookingId);

//         switch (action) {
//             case "In Process":
//                 await handleStatusUpdate(row.bookingId);
//                 break;
//             case "View":
//                 navigate(`/lab-scanning/view/${row.bookingId}`);
//                 break;
//         }
//     };

//     const handleAddNew = () => {
//         navigate("/lab-scan/add");
//     };

//     const columns: IColumns[] = [
//         { header: "Tracking ID", fieldName: "trackingId", type: "default" },
//         { header: "Customer", fieldName: "customerName", type: "default" },
//         { header: "Scan Name", fieldName: "testName", type: "default" },
//         { header: "Slot Date", fieldName: "slotDate", type: "date" },
//         { header: "Slot Time", fieldName: "slotTime", type: "default" },
//         { header: "Amount", fieldName: "formattedAmount", type: "default" },
//         { header: "Payment", fieldName: "paymentMethod", type: "default" },
//         { header: "Status", fieldName: "status", type: "status" },
//         {
//             header: "Actions",
//             fieldName: "actions",
//             type: "action",
//             actions: ["In Process", "View"],
//             actionCallback: (action, row) => handleAction(action, row as ScanBooking),
//         },
//     ];

//     const handleSnackbarClose = () => {
//         setSnackbar({ open: false, message: "", severity: "success" });
//     };

//     if (loading) {
//         return (
//             <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//                 <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
//                     <CircularProgress />
//                     <div style={{ marginLeft: 16 }}>Loading scan bookings...</div>
//                 </Grid>
//             </Grid>
//         );
//     }

//     return (
//         <>
//             <Grid container spacing={2}>
//                 <Grid item sm={3}>
//                     <WSDashboardCard
//                         title="Total Scans"
//                         value={summaryCounts.totalScans.toString()}
//                         percentage="+5%"
//                         bottomIcon={<TrendingUpIcon />}
//                         icon={<ShoppingCartIcon sx={{ color: "#098963" }} />}
//                     />
//                 </Grid>
//                 <Grid item sm={3}>
//                     <WSDashboardCard
//                         title="Completed"
//                         value={summaryCounts.completedScans.toString()}
//                         percentage="+15%"
//                         bottomIcon={<TrendingUpIcon />}
//                         icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
//                     />
//                 </Grid>
//                 <Grid item sm={3}>
//                     <WSDashboardCard
//                         title="Pending"
//                         value={summaryCounts.pendingScans.toString()}
//                         percentage="-3%"
//                         bottomIcon={<TrendingUpIcon />}
//                         icon={<WSIcons.OutOfStockIcon sx={{ color: "#ff9800" }} />}
//                     />
//                 </Grid>
//                 <Grid item sm={3}>
//                     <WSDashboardCard
//                         title="Today's Revenue"
//                         value={`₹${summaryCounts.revenueToday}`}
//                         percentage="+12%"
//                         bottomIcon={<TrendingUpIcon />}
//                         icon={<ShoppingCartIcon sx={{ color: "#098963" }} />}
//                     />
//                 </Grid>

//                 <Grid item sm={9}>
//                     <WSFilterButtonGroup
//                         options={filters.map(filter => getFilterLabel(filter))}
//                         selected={getFilterLabel(selectedFilter)}
//                         onChange={handleFilterChange}
//                     />
//                 </Grid>
//                 <Grid item sm={3} display="flex" justifyContent="flex-end">
//                     <WSButton
//                         id="btnAddNewScan"
//                         label="Add New Scan Booking"
//                         startIcon={<AddIcon />}
//                         onClick={handleAddNew}
//                         sx={{
//                             borderRadius: "999px",
//                             backgroundColor: "#098963!important",
//                             textTransform: "none",
//                             fontWeight: 500,
//                             height: "35px!important",
//                             fontSize: "0.875rem!important",
//                             paddingX: 3,
//                             paddingY: 1,
//                             "&:hover": { backgroundColor: "#087654!important" },
//                         }}
//                     />
//                 </Grid>
//             </Grid>

//             <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//                 <Grid item sm={12}>
//                     {error ? (
//                         <div style={{ padding: 20, color: 'red' }}>
//                             {error}. <button onClick={fetchScanBookings}>Retry</button>
//                         </div>
//                     ) : (
//                         <WSDataGridNew
//                             columns={columns}
//                             data={filteredData}
//                             id="labScanListGrid"
//                             title={`Scan Bookings (${filteredData.length})`}
//                             exportCsv={true}
//                             searchBox={{ fieldName: "customerName" }}
//                             gridHeaderSx={{
//                                 backgroundColor: "whitesmoke",
//                                 border: "1px solid whitesmoke",
//                             }}
//                         />
//                     )}
//                 </Grid>
//             </Grid>

//             {/* ✅ SNACKBAR for status feedback */}
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={4000}
//                 onClose={handleSnackbarClose}
//                 anchorOrigin={{ vertical: "top", horizontal: "right" }}
//             >
//                 <Alert
//                     onClose={handleSnackbarClose}
//                     severity={snackbar.severity}
//                     sx={{ width: "100%" }}
//                 >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </>
//     );
// });

// export default LabScanList;



import { Grid, CircularProgress, Snackbar, Alert } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import WSButton from "../../../Components/Button/WSButton";
import WSDataGridNew, {
    IColumns,
} from "../../../Components/DataGrid/WSDataGridNew";
import { WSIcons } from "../../../commonFunctions/iIcons";
import AddIcon from "@mui/icons-material/Add";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useNavigate } from "react-router-dom";
import { getLocalValue, LoacalVariables, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import http from "../../../commonFunctions/httpClient";

interface ScanBooking {
    bookingId: string;
    bookedOn: string;
    labName: string;
    labId: string;
    customerName: string;
    customerId: string;
    testName: string;
    slotDate: string;
    slotTime: string;
    paymentMethod: string;
    amount: number;
    resultAvailable: boolean;
    reportUrl: string | null;
    trackingId: string;
    status: string;
    itemTotal: number;
    discount: number;
    totalPayable: number;
    savings: number;
    formattedAmount: string;
}

interface SummaryCounts {
    totalScans: number;
    completedScans: number;
    pendingScans: number;
    inProcessScans: number;
    todayScans: number;
    revenueToday: number;
}

export const LabScanList: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();

    const filters = ["All", "Pending", "InProcess", "Completed", "Today"];
    const [selectedFilter, setSelectedFilter] = useState(filters[0]);
    const [data, setData] = useState<ScanBooking[]>([]);
    const [filteredData, setFilteredData] = useState<ScanBooking[]>([]);
    const [labId, setLabId] = useState<string>("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [apiLoading, setApiLoading] = useState<Set<string>>(new Set());
    const [snackbar, setSnackbar] = useState<{
        open: boolean;
        message: string;
        severity: "success" | "error" | "info";
    }>({
        open: false,
        message: "",
        severity: "success",
    });

    const [filterCounts, setFilterCounts] = useState<Record<string, number>>({
        All: 0,
        Pending: 0,
        InProcess: 0,
        Completed: 0,
        Today: 0,
    });

    const [summaryCounts, setSummaryCounts] = useState<SummaryCounts>({
        totalScans: 0,
        completedScans: 0,
        pendingScans: 0,
        inProcessScans: 0,
        todayScans: 0,
        revenueToday: 0,
    });

    useEffect(() => {
        updateMainHeader("Scan Bookings");
        breadCrumbsStore.updateBreadCrumbs([
            { "Scan Bookings": "labscan/list" },
        ]);
    }, []);

    useEffect(() => {
        const userId = getLocalValue(LoacalVariables.UserId);
        setLabId(userId || "");
    }, []);

    // ✅ FIXED: Filter counts include InProcess status
    const calculateFilterCounts = useCallback((scans: ScanBooking[]) => {
        const today = new Date().toISOString().split('T')[0];

        const counts: Record<string, number> = {
            All: scans.length,
            Pending: scans.filter(scan => scan.status === "Pending").length,
            InProcess: scans.filter(scan => scan.status === "InProcess").length,
            Completed: scans.filter(scan => scan.status === "Completed").length,
            Today: scans.filter(scan => scan.slotDate === today).length,
        };

        return counts;
    }, []);

    // ✅ FIXED: Check localStorage BEFORE setting status
    const fetchScanBookings = useCallback(async (): Promise<void> => {
        if (!labId) {
            setLoading(false);
            return;
        }

        try {
            setLoading(true);
            setError("");

            const response: any = await http.get(`lab/LabScanBooking/lab/${labId}`);
            const apiData = response.data || response || [];
            console.log("🔥 API Response:", response);

            const scanBookings: ScanBooking[] = [];

            if (Array.isArray(apiData)) {
                apiData.forEach((bookingGroup: any) => {
                    const users = bookingGroup.users || [];
                    const scanInfos = bookingGroup.scanBookingInfo || [];
                    const results = bookingGroup.results || [];
                    const tracking = bookingGroup.orderTracking || [{}];
                    const orderSummary = bookingGroup.orderSummary?.[0] || {};

                    scanInfos.forEach((info: any, index: number) => {
                        const user = users[0] || { name: "Unknown", customerProfileId: "" };
                        const result = results[index] || { resultAvailable: false, reportPdfUrl: null };
                        const track = tracking[0] || { trackingId: "", steps: [] };

                        // ✅ CRITICAL FIX: Check localStorage FIRST
                        const inProcessKey = `scan-inprocess-${info.bookingId}`;
                        const isInProcess = localStorage.getItem(inProcessKey) === "true";
                        
                        // ✅ Status priority: InProcess > Completed > Pending
                        const status = isInProcess
                            ? "InProcess"
                            : result.resultAvailable 
                                ? "Completed" 
                                : "Pending";

                        console.log(`🔍 Booking ${info.bookingId}: localStorage=${isInProcess}, resultAvailable=${result.resultAvailable}, finalStatus=${status}`);

                        scanBookings.push({
                            bookingId: info.bookingId,
                            bookedOn: info.bookedOn,
                            labName: info.lab?.labName || "Unknown Lab",
                            labId: info.lab?.labId || labId,
                            customerName: user.name,
                            customerId: user.customerProfileId,
                            testName: info.tests?.testName || "Unknown Scan",
                            slotDate: info.slot?.date?.split('T')[0] || "",
                            slotTime: info.slot?.time || "",
                            paymentMethod: info.payment?.method || "",
                            amount: info.payment?.amount || 0,
                            resultAvailable: result.resultAvailable || false,
                            reportUrl: result.reportPdfUrl || null,
                            trackingId: track.trackingId || "",
                            status,
                            itemTotal: orderSummary.itemTotal || 0,
                            discount: orderSummary.discount || 0,
                            totalPayable: orderSummary.totalPayable || 0,
                            savings: orderSummary.savings || 0,
                            formattedAmount: `₹${(orderSummary.totalPayable || 0).toFixed(2)}`,
                        });
                    });
                });
            }

            console.log("🔥 Final scanBookings:", scanBookings);
            setData(scanBookings);

            const counts = calculateFilterCounts(scanBookings);
            setFilterCounts(counts);
            setFilteredData(scanBookings);

        } catch (err: any) {
            console.error("❌ fetchScanBookings error:", err);
            setError(err.message || "Failed to fetch scan bookings");
            setData([]);
            setFilteredData([]);
        } finally {
            setLoading(false);
        }
    }, [labId, calculateFilterCounts]);

    const fetchSummaryCounts = useCallback(() => {
        if (!labId || data.length === 0) return;

        const today = new Date().toISOString().split('T')[0];
        const todayRevenue = data
            .filter(scan => scan.slotDate === today)
            .reduce((sum, scan) => sum + scan.totalPayable, 0);

        setSummaryCounts({
            totalScans: data.length,
            completedScans: data.filter(scan => scan.status === "Completed").length,
            pendingScans: data.filter(scan => scan.status === "Pending").length,
            inProcessScans: data.filter(scan => scan.status === "InProcess").length,
            todayScans: data.filter(scan => scan.slotDate === today).length,
            revenueToday: Math.round(todayRevenue),
        });
    }, [labId, data]);

    // ✅ FIXED: Persistent InProcess status
    const handleStatusUpdate = useCallback(async (bookingId: string) => {
        console.log("🔄 handleStatusUpdate called with:", bookingId);

        const inProcessKey = `scan-inprocess-${bookingId}`;
        const currentScan = data.find(r => r.bookingId === bookingId);
        
        if (!currentScan) {
            setSnackbar({ open: true, message: "Scan booking not found", severity: "error" });
            return;
        }

        if (currentScan.status === "InProcess") {
            setSnackbar({ open: true, message: `Scan already in process`, severity: "info" });
            return;
        }

        setApiLoading((prev) => {
            const s = new Set(prev);
            s.add(bookingId);
            return s;
        });

        try {
            const response: any = await http.put(`lab/LabScanBooking/start-processing/${bookingId}`, {});
            console.log("📥 API RESPONSE:", response);

            // ✅ CRITICAL: Save to localStorage FIRST (persists across refresh)
            localStorage.setItem(inProcessKey, "true");

            // ✅ Then update local state immediately
            const updatedData = data.map(scan => 
                scan.bookingId === bookingId
                    ? { ...scan, status: "InProcess" }
                    : scan
            );
            setData(updatedData);
            setFilteredData(updatedData);

            setSnackbar({
                open: true,
                message: `Scan processing started ✅`,
                severity: "success",
            });

        } catch (error: any) {
            console.error("❌ Error:", error);
            localStorage.removeItem(inProcessKey); // Cleanup on error
            setSnackbar({ 
                open: true, 
                message: error?.response?.data?.message || "Failed to start processing", 
                severity: "error" 
            });
        } finally {
            setApiLoading((prev) => {
                const s = new Set(prev);
                s.delete(bookingId);
                return s;
            });
        }
    }, [data]);

    useEffect(() => {
        if (labId) {
            fetchScanBookings();
        }
    }, [labId, fetchScanBookings]);

    useEffect(() => {
        fetchSummaryCounts();
    }, [data, fetchSummaryCounts]);

    const handleFilterChange = useCallback((value: string) => {
        const originalFilter = value.replace(/\(\d+\)$/, "").trim();
        setSelectedFilter(originalFilter);

        const today = new Date().toISOString().split('T')[0];

        if (originalFilter === "All") {
            setFilteredData(data);
        } else if (originalFilter === "Today") {
            setFilteredData(data.filter(scan => scan.slotDate === today));
        } else if (originalFilter === "Pending") {
            setFilteredData(data.filter(scan => scan.status === "Pending"));
        } else if (originalFilter === "InProcess") {
            setFilteredData(data.filter(scan => scan.status === "InProcess"));
        } else if (originalFilter === "Completed") {
            setFilteredData(data.filter(scan => scan.status === "Completed"));
        }
    }, [data]);

    const getFilterLabel = useCallback((filter: string) => {
        const count = filterCounts[filter] || 0;
        return `${filter}(${count})`;
    }, [filterCounts]);

    useEffect(() => {
        if (data.length > 0) {
            const counts = calculateFilterCounts(data);
            setFilterCounts(counts);
        }
    }, [data, calculateFilterCounts]);

    const handleAction = async (action: string, row: ScanBooking) => {
        console.log("Action:", action, "Row ID:", row.bookingId);

        switch (action) {
            case "In Process":
                await handleStatusUpdate(row.bookingId);
                break;
            case "View":
                navigate(`/lab-scanning/view/${row.bookingId}`);
                break;
        }
    };

    // const handleAddNew = () => {
    //     navigate("/lab-scan/add");
    // };

    const columns: IColumns[] = [
        { header: "Tracking ID", fieldName: "trackingId", type: "default" },
        { header: "Customer", fieldName: "customerName", type: "default" },
        { header: "Scan Name", fieldName: "testName", type: "default" },
        { header: "Slot Date", fieldName: "slotDate", type: "date" },
        { header: "Slot Time", fieldName: "slotTime", type: "default" },
        { header: "Amount", fieldName: "formattedAmount", type: "default" },
        { header: "Payment", fieldName: "paymentMethod", type: "default" },
        { header: "Status", fieldName: "status", type: "status" },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: ["In Process", "View"],
            actionCallback: (action, row) => handleAction(action, row as ScanBooking),
        },
    ];

    const handleSnackbarClose = () => {
        setSnackbar({ open: false, message: "", severity: "success" });
    };

    if (loading) {
        return (
            <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
                <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                    <CircularProgress />
                    <div style={{ marginLeft: 16 }}>Loading scan bookings...</div>
                </Grid>
            </Grid>
        );
    }

    return (
        <>
            <Grid container spacing={2}>
                <Grid item sm={3}>
                    <WSDashboardCard
                        title="Total Scans"
                        value={summaryCounts.totalScans.toString()}
                        percentage="+5%"
                        bottomIcon={<TrendingUpIcon />}
                        icon={<ShoppingCartIcon sx={{ color: "#098963" }} />}
                    />
                </Grid>
                <Grid item sm={3}>
                    <WSDashboardCard
                        title="Completed"
                        value={summaryCounts.completedScans.toString()}
                        percentage="+15%"
                        bottomIcon={<TrendingUpIcon />}
                        icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
                    />
                </Grid>
                <Grid item sm={3}>
                    <WSDashboardCard
                        title="Pending"
                        value={summaryCounts.pendingScans.toString()}
                        percentage="-3%"
                        bottomIcon={<TrendingUpIcon />}
                        icon={<WSIcons.OutOfStockIcon sx={{ color: "#ff9800" }} />}
                    />
                </Grid>
                <Grid item sm={3}>
                    <WSDashboardCard
                        title="In Process"
                        value={summaryCounts.inProcessScans.toString()}
                        percentage="+8%"
                        bottomIcon={<TrendingUpIcon />}
                        icon={<ShoppingCartIcon sx={{ color: "#2196f3" }} />}
                    />
                </Grid>

                <Grid item sm={9}>
                    <WSFilterButtonGroup
                        options={filters.map(filter => getFilterLabel(filter))}
                        selected={getFilterLabel(selectedFilter)}
                        onChange={handleFilterChange}
                    />
                </Grid>
                <Grid item sm={3} display="flex" justifyContent="flex-end">
                    {/* <WSButton
                        id="btnAddNewScan"
                        label="Add New Scan Booking"
                        startIcon={<AddIcon />}
                        // onClick={handleAddNew}
                        sx={{
                            borderRadius: "999px",
                            backgroundColor: "#098963!important",
                            textTransform: "none",
                            fontWeight: 500,
                            height: "35px!important",
                            fontSize: "0.875rem!important",
                            paddingX: 3,
                            paddingY: 1,
                            "&:hover": { backgroundColor: "#087654!important" },
                        }}
                    /> */}
                </Grid>
            </Grid>

            <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
                <Grid item sm={12}>
                    {error ? (
                        <div style={{ padding: 20, color: 'red' }}>
                            {error}. <button onClick={fetchScanBookings}>Retry</button>
                        </div>
                    ) : (
                        <WSDataGridNew
                            columns={columns}
                            data={filteredData}
                            id="labScanListGrid"
                            title={`Scan Bookings (${filteredData.length})`}
                            exportCsv={true}
                            searchBox={{ fieldName: "customerName" }}
                            gridHeaderSx={{
                                backgroundColor: "whitesmoke",
                                border: "1px solid whitesmoke",
                            }}
                        />
                    )}
                </Grid>
            </Grid>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity={snackbar.severity}
                    sx={{ width: "100%" }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
});

export default LabScanList;
